/**
 * チャットUIの自動スクロール判定 (AiMenuChatPage.tsx/ProfileBuilderChatPage.tsx で共通利用)。
 * テストレビュー反映 (2026-08-02): 同じ判定式が2ファイルに重複しており、DOM操作に密結合していたため
 * 単体テストが書けず、距離ベース判定の不具合 (一度上にスクロールすると自動追従が復帰しない) が
 * 本番で2回連続して発生していた。純関数として切り出しテスト可能にする。
 */

/** スクロールコンテナが最下部付近 (閾値px以内) にいるかどうかを判定する */
export const isNearBottom = (
  scrollHeight: number,
  scrollTop: number,
  clientHeight: number,
  threshold = 60,
): boolean => scrollHeight - scrollTop - clientHeight < threshold;

// 末尾が user 発言のまま応答が保存されない場合 (サーバー側の異常終了等) でも「生成中」を永久に
// 表示し続けないための上限。正常系の最長 (menu_dev: 1呼出3分のstallガード × 最大6反復 = 18分、
// profile_builder: 90秒 × 6反復 = 9分) に余裕を持たせ、まだ生成中の応答を誤って打ち切らない
// (2026-10-01 本番報告: 60分間「生成中」のまま)
export const AWAITING_RESPONSE_GIVE_UP_MS = 30 * 60 * 1000;

/** 末尾の user 発言から上限時間を過ぎても応答が無く、「生成中」とみなすのをやめるべきか */
export const isAwaitingGivenUp = (
  lastMessage: { role: string; created_at: string } | undefined,
  now: number,
): boolean =>
  lastMessage?.role === 'user' && now - new Date(lastMessage.created_at).getTime() > AWAITING_RESPONSE_GIVE_UP_MS;
